<template>
  <div class="conteudoInterno" id="atividades">
    <div class="boxSeta">
      <div
        class="setaScrollstatic"
        style=""
        :class="{
          setaScroll: setaScrollState,
        }"
      >
        <button>
          <span><i class="bottom"></i></span>
        </button>
      </div>
    </div>
    <header class="headerSec">
      <h2>Principais Atividades</h2>
      <div class="navSetas">
        <button @click="goBack()" :disabled="clicked">
          <span><i class="left"></i></span>
        </button>
        <button @click="goNext()" :disabled="clicked">
          <span :class="{ hideSeta: setaRightState }"
            ><i class="right"></i
          ></span>
        </button>
      </div>
      <!-- <span></span> -->
    </header>
    <div class="conteudoInternoBox">
      <section class="sectionRow">
        <div class="col23ponto5 marginColBottom">
          <span class="linecol ubcPurpleBack"></span>
        </div>
      </section>
      <section class="sectionRow top65">
        <div class="col23ponto5"></div>
        <div class="col66">
          <h4 class="h4Destaque">
            Prêmio UBC para
            <span class="ubcPurple sanukBlack">Zeca Pagodinho</span>
          </h4>

          <p class="top32">
            Em sua nona edição, o Prêmio do Compositor Brasileiro homenageou
            pela primeira vez um sambista. Na Casa UBC, no Rio de Janeiro, doze
            canções do repertório de Zeca foram interpretadas por grandes nomes
            da música brasileira — de Gilberto Gil a João Gomes —, unindo
            gerações em uma noite que transformou o espaço em uma autêntica roda
            de samba.
            <a
              href="https://www.youtube.com/watch?v=1eIIEXdT5PE"
              target="_blank"
              >Assista +</a
            >
          </p>

          <div class="button top32">
            <button class="sanukBold"></button>
          </div>

          <!-- <div class="hidden" v-show="value1">
            <p>Mais conteúdo?</p>
          </div>
          <div v-show="!value1" class="button top32" v-on:click="value1 = !value1" :disabled="clicked">
            <button class="sanukBold"><span>Leia mais </span><div class="leiaMais"></div></button>
          </div>
          <div v-show="value1" class="button top32" v-on:click="value1 = !value1" :disabled="clicked">
            <button class="sanukBold"><span>Fechar  </span><div class="fechar"></div></button>
          </div> -->

          <h4 class="h4Destaque top50">
            Relatório
            <span class="ubcPurple sanukBlack"
              >Por Elas Que Fazem a Música + SongCamp com a SPA</span
            >
          </h4>
          <p class="top32">
            Há oito anos, a UBC acompanha a participação das mulheres na música
            brasileira, e cada edição do Por Elas Que Fazem a Música registra
            avanços e desafios. Nesse período, o número de associadas cresceu
            210%. Como desdobramento, a segunda temporada do SongCamp reuniu
            brasileiras e portuguesas em parceria inédita com a Sociedade
            Portuguesa de Autores (SPA), resultando em "Flor de Asfalto", canção
            sobre travessias, cura e resistência, celebrada em série documental
            no YouTube da UBC.
            <a
              href="https://www.canva.com/design/DAGcRgCB-Mc/FYAuAOG-3V5axkVRRfpR8A/view?utm_content=DAGcRgCB-Mc&%20(URL%20pode%20ser%20maliciosa);utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h08053e7cf9#1"
              target="_blank"
              >Leia +</a
            >
            &nbsp;
            <a
              href="https://www.youtube.com/watch?v=EhW_kNvpKEE&list=PLK2i8iPUlTrImgDRM_7MoBjASbN7TKuCd"
              target="_blank"
              >Veja +</a
            >
          </p>

          <div class="button top32">
            <button class="sanukBold"></button>
          </div>

          <!-- <div class="hidden" v-show="value2">
            <p>Mais conteúdo?</p>            
          </div>
          <div v-show="!value2" class="button top32" v-on:click="value2 = !value2" :disabled="clicked">
            <button class="sanukBold" ><span>Leia mais </span><div class="leiaMais"></div></button>
          </div>
          <div v-show="value2" class="button top32" v-on:click="value2 = !value2" :disabled="clicked">
            <button class="sanukBold" ><span>Fechar </span><div class="fechar"></div></button>
          </div> -->

          <h4 class="h4Destaque top50">
            Tradições UBC para
            <span class="ubcPurple sanukBlack">Rosa Passos</span>
          </h4>

          <p class="top32">
            Em homenagem a Rosa Passos, a UBC celebrou a cantora, compositora e
            violonista baiana que conquistou palcos no mundo inteiro antes de
            receber o devido reconhecimento em seu próprio país. Na Casa UBC,
            ela apresentou o show "Suíte Brasileira" ao lado de Paula Lima,
            Fernanda Takai e Vanessa Moreno, em uma noite de emoção e música ao
            vivo que marcou a 5ª edição do Troféu Tradições.
            <a
              href="https://www.youtube.com/watch?v=pQ5sg9-KFCk&list=PLK2i8iPUlTrJXb5xu1WpLMDvt1H72yIKs"
              target="_blank"
              >Confira +</a
            >
          </p>

          <div class="button top32">
            <button class="sanukBold"></button>
          </div>

          <h4 class="h4Destaque top50">
            2ª Temporada do
            <span class="ubcPurple sanukBlack">Palavra de Autor</span>
          </h4>

          <p class="top32">
            O webcast original da UBC conduzido por Celso Fonseca ganhou 13
            novos episódios, gravados no estúdio Sonastério, em Minas Gerais.
            Celebrando a riqueza da música mineira e brasileira, a temporada
            reuniu artistas como Beto Guedes, Mauricio Tizumba, Paulinho Pedra
            Azul e Fernanda Takai, em bate-papos descontraídos que revelam os
            bastidores e as emoções por trás de grandes canções.
            <a
              href="https://www.youtube.com/watch?v=qAl_L1zfrFI&list=PLK2i8iPUlTrLgwu0gv-Z2OFkORwAfNmRQ"
              target="_blank"
              >Veja +</a
            >
          </p>

          <div class="button top32">
            <button class="sanukBold"></button>
          </div>

          <h4 class="h4Destaque top50">
            Medalha UBC para
            <span class="ubcPurple sanukBlack">Luiz Caldas</span>
          </h4>

          <p class="top32">
            Nos 40 anos do álbum "Magia" e da axé music, a UBC entregou a Luiz
            Caldas a Medalha UBC, em Salvador. O cantor e compositor baiano foi
            celebrado em uma noite especial com Carlinhos Brown, Saulo Fernandes
            e outros grandes nomes, em uma homenagem justa à sua inventividade e
            ao impacto duradouro de sua obra na música nacional.
            <a
              href="https://www.ubc.org.br/publicacoes/noticias/luiz-caldas-recebe-medalha-ubc-em-noite-de-estrelas-e-musica"
              target="_blank"
              >Leia +</a
            >
          </p>

          <div class="button top32">
            <button class="sanukBold"></button>
          </div>

          <h4 class="h4Destaque top50">
            <span class="ubcPurple sanukBlack">Novo site da UBC</span> e a
            assistente virtual
            <span class="ubcPurple sanukBlack">Chiquinha</span>
          </h4>

          <p class="top32">
            Mais moderna, rápida e acessível, a UBC estreou um site totalmente
            reformulado, disponível em três idiomas e com novos recursos de
            acessibilidade. A grande novidade é a Chiquinha, assistente virtual
            inspirada em Chiquinha Gonzaga, que orienta usuários em tempo real
            sobre filiação, cadastro de obras, pagamentos e muito mais.
            <a
              href="https://www.ubc.org.br/publicacoes/noticias/nova-cara-mais-agilidade-e-uma-ajudante-virtual-conheca-o-novo-site-da-ubc"
              target="_blank"
              >Saiba +</a
            >
          </p>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { ShareFunctions } from "../assets/js/functions.js";

export default {
  name: "AtividadesPrincipais",
  props: ["clicked"],

  data() {
    return {
      setaScrollState: false,
      setaRightState: false,
      value1: false,
      value2: false,
    };
  },
  mounted() {
    const conteudo = document.querySelector("#atividades");
    conteudo.addEventListener("scroll", ShareFunctions.headerScroll);
  },
  created() {
    this.hideSetaFunc();
  },
  methods: {
    hideSetaFunc: function () {
      let route = this.$route.path;
      if (route === "/AtividadesPrincipais") {
        this.setaRightState = true;
      } else {
        this.setaRightState = false;
      }
    },
    goNext: function () {
      this.$emit("go-next");
    },
    goBack: function () {
      this.$emit("go-back");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
p a {
  color: #8781d1;
  font-family: "sanuk-bold";
}
.button {
  width: 100%;
  border-bottom: 1px solid #8781d1;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 32px;
}
button {
  color: #8781d1;
  cursor: pointer;
  padding-bottom: 4px;
  display: flex;
}
.hidden {
  opacity: 1;
  max-height: auto;
  overflow: hidden;
  animation: open 0.75s ease-in;
}
@keyframes open {
  0% {
    max-height: 0;
    opacity: 0;
  }
  100% {
    max-height: 2000px;
    opacity: 1;
  }
}
.leiaMais::before,
.leiaMais::after,
.fechar::before,
.fechar::after {
  content: "";
  position: absolute;
  background-color: #8781d1;
  transition: transform 0.25s ease-out;
}
.leiaMais {
  position: relative;
  width: 15px;
  height: 15px;
  margin-left: 10px;
}
.leiaMais::before {
  top: 0;
  left: Calc(50% - 1.5px);
  width: 3px;
  height: 100%;
}
.leiaMais::after {
  top: 50%;
  left: 0;
  width: 100%;
  height: 3px;
  margin-top: -1.5px;
}
.fechar {
  position: relative;
  width: 15px;
  height: 15px;
  margin-left: 10px;
}
.fechar::before {
  top: 0;
  left: Calc(50% - 1.5px);
  width: 3px;
  height: 100%;
  margin-left: -1.5px;
  transform: rotate(90deg);
}
.fechar::after {
  top: 50%;
  left: 0;
  width: 100%;
  height: 3px;
  margin-top: -1.5px;
}
</style>
